var render, staticRenderFns
import script from "./ReportAccountStatusImportRemainRD.vue?vue&type=script&lang=js&"
export * from "./ReportAccountStatusImportRemainRD.vue?vue&type=script&lang=js&"
import style0 from "./ReportAccountStatusImportRemainRD.vue?vue&type=style&index=0&id=e8fdc25e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fdc25e",
  null
  
)

export default component.exports